module.exports = __webpack_public_path__ + "static/san-fran-ts-0aee12f05cdb3dd9ec30a240cb2182bc.jpg";